/**
 * @file SpecialtyCommands.js
 * @description System utility commands for CyberOS.
 */

import { CommandBase } from "../CommandBase.js";
import { Utils } from "../../../system/utils/utils.js";

// --- SYSTEM INFORMATION ---

/** Handles the 'uname' command */
export class UnameCommand extends CommandBase {
    async execute(args) {
        // Using a themed block style for system info
        const output = `
            <div class="system-message-header">SYSTEM ARCHITECTURE</div>
            <div class="system-message-body">
                <p>CyberOS v3.5 (NEXUS) x86_64</p>
                <p class="text-muted">Kernel: Darwin 23.4.0 / Environment: Terminal-Interactive</p>
            </div>
        `;
        this.terminal.writeHTML(output);
    }
}

/** Handles the 'date' command */
export class DateCommand extends CommandBase {
    async execute(args) {
        this.write(new Date().toString());
    }
}

// --- THEME MANAGEMENT ---

/** Handles the 'themes' command - Lists available options */
export class ThemesCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        this.themeManager = kernel.get('theme');
    }
    async execute(args) {
        const list = this.themeManager.getThemes().join(', ');
        this.write(`Available theme protocols: [ ${list} ]`, 'text-accent');
    }
}

/** Handles the 'theme' command - Executes the transition */
export class ThemeCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        this.themeManager = kernel.get('theme');
    }
    
    async execute(args) {
        const themeName = args[0];
        
        if (!themeName) {
            this.write("Usage: theme [name]", "text-muted");
            return;
        }

        // Pass 'true' for isInteractive so the transition overlay shows up
        const result = await this.themeManager.handleThemeCommand(themeName, true);
        
        // Output the result of the change (Error or Success message)
        this.write(result);
    }
}

// --- MISC / UTILITIES ---

/** Handles the 'fortune' command */
export class FortuneCommand extends CommandBase {
    async execute(args) {
        const fortunes = this.contentManager.getFortunes();
        const quote = fortunes[Utils.randomInt(0, fortunes.length - 1)];
        this.write(`\n  "${quote}"\n`, 'text-accent');
    }
}

/** Handles the 'echo' command */
export class EchoCommand extends CommandBase {
    async execute(args) {
        this.write(args.join(' '));
    }
}

/** Handles the 'sudo' easter egg */
export class SudoCommand extends CommandBase {
    async execute(args) {
        // Added a "danger" class to match your status colors
        this.write("sudo: user not in sudoers file. This incident will be reported.", 'text-danger');
    }
}